import React from "react";
import AppErrorMessage from "./AppErrorMessage/AppErrorMessage";

// Inspired from https://reactjs.org/docs/error-boundaries.html
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <AppErrorMessage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
